module.exports = __webpack_public_path__ + "static/guardian_naga-7fea29148b805a068b12bb971d229a4c.jpeg";